import { Bar } from "./Bar";
import { Circle } from "./Circle";

export const Progress = {
  Bar,
  Circle,
};
